import { render } from "./OurCompanyView.vue?vue&type=template&id=1e4e3b08&scoped=true&ts=true"
import script from "./OurCompanyView.vue?vue&type=script&lang=ts"
export * from "./OurCompanyView.vue?vue&type=script&lang=ts"

import "./OurCompanyView.vue?vue&type=style&index=0&id=1e4e3b08&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4e3b08"]])

export default __exports__